import { render } from "./PreparationDirections.vue?vue&type=template&id=14981d0f&scoped=true&ts=true"
import script from "./PreparationDirections.vue?vue&type=script&lang=ts"
export * from "./PreparationDirections.vue?vue&type=script&lang=ts"

import "./PreparationDirections.vue?vue&type=style&index=0&id=14981d0f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14981d0f"]])

export default __exports__